import React, { useMemo, useRef, useCallback } from 'react';
import styled from 'styled-components';

import useFlavorStore from '../../../../../common/store/useFlavorStore';
import Container from '../../Container';
import { getVh } from '../../utils';
import useAnimation from './useAnimation';
import useParallax from '../../useParallax';

const Fruit = styled.img`
  aspect-ratio: 437/405;
  width: auto;
  height: 40vh;
  min-height: 200rem;

  transform: rotate(20deg);
`;

const Americano = styled.img`
  aspect-ratio: 248/225;
  width: auto;
  height: 150rem;
`;

const Apple = () => {

  const flavor = useFlavorStore(useCallback(state => state.flavor, []));

  const ref = {
    figure: {
      fruit: useRef<HTMLElement>(null),
      americano: useRef<HTMLElement>(null)
    },
    img: {
      fruit: useRef<HTMLImageElement>(null),
      americano: useRef<HTMLImageElement>(null)
    }
  }

  const top = {
    fruit: useMemo(() => getVh("flavor", 0.5), []),
    americano: useMemo(() => getVh("flavor", 0.2), [])
  }

  useAnimation(flavor === "apple", [ref.figure.fruit, ref.figure.americano]);

  useParallax(ref.img.fruit, top.fruit, 100);
  useParallax(ref.img.americano, top.americano, 50);

  return (
    <>
      <Container
        ref={ref.figure.fruit}
        top={top.fruit}
        style={{ left: "55vw" }}
      >
        <Fruit
          ref={ref.img.fruit}
          src="/static/images/fill/apple.png"
        />
      </Container>

      <Container
        ref={ref.figure.americano}
        top={top.americano}
        style={{ left: "80vw" }}
      >
        <Americano
          ref={ref.img.americano}
          src="/static/images/fill/americano.png"
        />
      </Container>
    </>
  );
}

export default Apple;